export const ROUTES = {
  home: '/',
  login: '/login',
  createAccount: '/create-account',
  createPassword: '/create-password',
  forgotPassword: '/login/reset',
  existingAccount: '/existing-account',
  shop: '/shop',
  cart: '/shop/cart',
  cartSuccess: '/shop/cart/success',
  packagesShop: '/shop/pk',
  giftCardsShop: '/shop/gc',
  productsShop: '/shop/prs',
  membershipShop: '/shop/mshps',
  giftCardsShopSteps: {
    selectStyles: '/shop/gc',
    selectAmount: '/shop/gc/select-amount',
    createAccount: '/shop/gc/create-account',
    details: '/shop/gc/details',
    cartDetails: '/shop/gc/cart-details',
    paymentDetails: '/shop/gc/payment-details',
    finalStep: '/shop/gc/success'
  },
  booking: '/book',
  welcome: '/welcome',
  dashboard: '/a',
  appointments: '/a/appt',
  memberships: '/a/mshps',
  membershipsPayment: '/a/mshps/payment',
  referFriend: '/a/ref',
  upcomingAppointment: '/a/appt/upcoming',
  recentAppointment: '/a/appt/recent',
  forms: '/a/fm',
  services: '/a/sv',
  packages: '/a/pk',
  products: '/a/pr',
  productsBrowse: '/a/pr/browse',
  orders: '/a/purchases',
  giftCards: '/a/gc',
  absoluteProfilePath: '/a/profile',
  profile: '/a/profile/details',
  addresses: '/a/profile/addr',
  creditCards: '/a/profile/cc',
  preferences: '/a/profile/prefs',
  guestCheckout: '/guest-checkout'
};

type RoutesType = Partial<typeof ROUTES>;

type FlattenRoutes<T> = T extends object
  ? {
      [K in keyof T]-?: T[K] extends string | undefined
        ? K
        : FlattenRoutes<T[K]>;
    }[keyof T]
  : never;

export type AllRoutes = FlattenRoutes<RoutesType>;

const getKeyByValue = (path: string): AllRoutes | undefined => {
  const flatRoutes = Object.keys(ROUTES).reduce(
    (acc, key) => {
      const value = ROUTES[key as keyof RoutesType];
      if (typeof value === 'object') {
        Object.assign(acc, value);
      } else {
        acc[key] = value;
      }
      return acc;
    },
    {} as { [key: string]: string }
  );

  return Object.keys(flatRoutes).find((key) => flatRoutes[key] === path) as
    | AllRoutes
    | undefined;
};

export const getAreaIdByName = (
  areaIds: { [key in AllRoutes]?: number },
  path: string
): number | null => {
  let name;

  if (path?.includes(ROUTES.dashboard)) {
    name = ROUTES.dashboard;
  } else if (path?.includes(ROUTES.giftCardsShop)) {
    name = ROUTES.giftCardsShop;
  } else {
    name = path;
  }

  const currentKey = getKeyByValue(name);

  return currentKey ? areaIds[currentKey] ?? null : null;
};
